import { IconType } from "react-icons";
import { FaUser } from "react-icons/fa";
import { SiGooglecalendar } from "react-icons/si";
import { SlNote } from "react-icons/sl";
import { useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";
import { RootState } from "src/redux/store";
import WebCourseSideBarLayout from "./WebCourseSideBarLayout/WebCourseSideBarLayout";
import { memo, useCallback, useEffect, useState } from "react";
import { useGetWebcourseByIdQuery } from "src/services/WebcourseServices";
import { CircularProgress } from "@mui/material";

type Props = {};

export const webcourseTabs: {
  label: string;
  icon: IconType;
  path: string;
  moduleName: string;
  actionName: string;
}[] = [
    {
      label: "Description",
      icon: FaUser,
      path: "details",
      moduleName: UserModuleNameTypes.BATCHES,
      actionName: UserModuleActionTypes.BATCHES_STUDENTS,
    },
    {
      label: "Course Content",
      icon: SlNote,
      path: "course-content",
      moduleName: UserModuleNameTypes.BATCHES,
      actionName: UserModuleActionTypes.BATCHES_ASSIGNMENTS,
    },
    {
      label: "Additional Details",
      icon: SiGooglecalendar,
      path: "additional-details",
      moduleName: UserModuleNameTypes.BATCHES,
      actionName: UserModuleActionTypes.BATCHES_ATTENDANCE,
    },
  ];

const WebCourseLayout = (props: Props) => {
  const { id = '' } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split("/")[4];

  const { userType } = useSelector((state: RootState) => state.auth);
  const [webCourseDataLayout, setWebCourseDataData] = useState<any>({});

  const { data, isLoading, isFetching } = useGetWebcourseByIdQuery(id, { skip: !id });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setWebCourseDataData(data?.data);
    }
  }, [data, isLoading, isFetching]);

  const handleTabClick = useCallback((path: string) => {
    navigate(path);
  }, [navigate]);

  return (
    <div className="grid grid-cols-12">

      <div className="md:col-span-4 lg:col-span-3 xl:col-span-2 xxl:col-span-2">
        <WebCourseSideBarLayout />
      </div>
      {(isLoading || isFetching) && (
        <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
          <CircularProgress />
        </div>
      )}
      <div className="md:col-span-8 lg:col-span-9 xl:col-span-10 xxl:col-span-10">
        <div className="flex flex-col gap-2 pt-3 h-full">
          {/* inquiriesEditTabs */}
          {webcourseTabs?.length && (
            <div className="flex gap-3 items-center  mx-4  border-b border-slate-400 bg-white ">
              {webcourseTabs
                ?.filter((module: any) =>
                  userType === "ADMIN"
                    ? true
                    : isCheckActionsPermission({
                      moduleName: module?.moduleName,
                      actionName: module?.actionName,
                    })
                )
                ?.map((tab: any, index: any) => {
                  return (
                    <div key={index}>
                      <button
                        type="button"
                        onClick={() => handleTabClick(tab.path)}
                        className={`h-full px-5 pb-2 flex gap-2 border-b-[3px]  items-center hover:text-primary-main font-medium text-sm transition-all
      ${currentPath === tab.path?.split("/")[0]
                            ? "text-primary-main   border-primary-main"
                            : "text-gray-700 border-white"
                          }
       `}
                      >
                        <div className=" text-lg  ">
                          <tab.icon />
                        </div>
                        {tab?.label}
                      </button>
                    </div>
                  );
                })}
            </div>
          )}

          {/* Outlet */}
          <div className=" flex-1 flex flex-col overflow-auto ">
            <div className="flex-1">
              <Outlet context={{ webCourseDataLayout }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(WebCourseLayout);
